import { AdbScrcpyOptions2_1 } from "./2_1.js";

export class AdbScrcpyOptionsLatest extends AdbScrcpyOptions2_1 {}
